var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PageHeader',{attrs:{"pageTitle":'Dashboard'},scopedSlots:_vm._u([{key:"description",fn:function(){return [_vm._v("\n      "+_vm._s(_vm.$tc('admin_dashboard_description'))+"\n    ")]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }